// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"PostDetailsPage_emptyWrapper__JM73U","emptyText":"PostDetailsPage_emptyText__ummtx"};